import React from "react";
import type { CommonFinanceInfoType, PriceType } from "../../../../../../../common-deprecated/types/CommonTypes";
import MonthlyRateDisclaimer from "./MonthlyRateDisclaimer";
import PricePromoIcon from "./PricePromoIcon";
import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import { BnbLabel } from "../../../../utils/labels";
import { formatMonthlyFinancePrice } from "../../../../../../shared-logic/utils/priceUtils";
import { useBnbSelector } from "../../../../redux/store";
import { hasDualCurrency } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";

type MonthlyPriceType = {
    price: PriceType;
    priceFormat: string;
    financeInfo: CommonFinanceInfoType;
    forceMonthlyDisclaimer?: boolean; // Passed into MonthlyRateDisclaimer to force ignore the flexibility matrix configuration
    forceHideDisclaimer?: boolean; // Used when the MonthlyRateDisclaimer needs to be shown in different location, see FinanceService, takes precedence over forceMonthlyDisclaimer
    showLoader?: boolean; // shows loader when true
    size?: "small" | "large";
};

// Render a monthly price.
const MonthlyPrice = (props: MonthlyPriceType): JSX.Element | null => {
    const { price, priceFormat, financeInfo, size } = props;
    const { forceMonthlyDisclaimer, forceHideDisclaimer, showLoader } = props;

    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const { hideFinanceTooltip } = commonSettings;

    const { labels = [], secondaryLabels = [] } = formatMonthlyFinancePrice(
        price,
        financeInfo,
        commonSettings,
        priceFormat,
        price.monthly,
        true,
    );
    const promotions = price.promotions.concat(price.onlineMonthlyPromotions);
    const hasSecondaryPrice = hasDualCurrency(commonSettings);
    if (!price.monthly) return null;

    if (showLoader)
        return (
            <Styles.Text>
                <BnbLabel label="priceLoading" fallbackLabel="spinLoading" />
            </Styles.Text>
        );

    return (
        <Styles.PricesWrapper>
            {labels.map((item, index) => (
                <div key={item.key}>
                    <Styles.Text
                        dangerouslySetInnerHTML={{ __html: item.value }}
                        color={size === "small" ? "grey4" : undefined}
                        isSmall={size === "small"}
                        isLarge={size === "large"}
                    />
                    {promotions.length > 0 && index < 1 && !hasSecondaryPrice && secondaryLabels.length === 0 && (
                        <PricePromoIcon promotions={promotions} />
                    )}
                </div>
            ))}
            {secondaryLabels.map((item, index) => (
                <div key={item.key}>
                    <Styles.Text
                        dangerouslySetInnerHTML={{ __html: item.value }}
                        color={size === "small" ? "grey4" : undefined}
                        isSmall={size === "small"}
                        isLarge={size === "large"}
                    />
                    {promotions.length > 0 && index < 1 && <PricePromoIcon promotions={promotions} />}
                </div>
            ))}
            {!hideFinanceTooltip && !forceHideDisclaimer && (
                <MonthlyRateDisclaimer
                    price={price}
                    priceFormat={priceFormat}
                    financeInfo={financeInfo}
                    forceMonthlyDisclaimer={forceMonthlyDisclaimer}
                />
            )}
        </Styles.PricesWrapper>
    );
};

export default MonthlyPrice;
